
import Vue from "vue";
import { generate_random_key } from "@/utils/global";

export default Vue.extend({
  name: "OtherSpecifications",
  methods: { generate_random_key }
});
